
export const TransferIcon = () => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.69999 0.771461C7.69999 0.453334 7.50477 0.167834 7.20825 0.0525106C6.91176 -0.062823 6.57488 0.0156776 6.35992 0.250192L0.702785 6.42161C0.496063 6.64712 0.442135 6.9735 0.565317 7.25348C0.688508 7.53356 0.965523 7.71428 1.27145 7.71428H17.7286C18.1546 7.71428 18.5 7.36889 18.5 6.94285C18.5 6.51684 18.1546 6.17145 17.7286 6.17145H7.69999V0.771461Z"
        fill="white" />
      <path
        d="M11.3 17.2286V11.8286H1.27143C0.845373 11.8286 0.5 11.4832 0.5 11.0572C0.5 10.6311 0.845373 10.2857 1.27143 10.2857H17.7285C18.0344 10.2857 18.3115 10.4666 18.4346 10.7465C18.5579 11.0266 18.504 11.353 18.2972 11.5784L12.6401 17.7499C12.4251 17.9844 12.0883 18.0629 11.7917 17.9475C11.4953 17.8322 11.3 17.5467 11.3 17.2286Z"
        fill="white" />
    </svg>
  )
}
